// extracted by mini-css-extract-plugin
module.exports = {"indBikeParentDiv":"indBike_indBikeParentDiv__3ZVo9","bikeDetails":"indBike_bikeDetails__1zqeE","subsDetails":"indBike_subsDetails__3IGV4","ratesDiv":"indBike_ratesDiv__3CMYE"};